<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="名稱" prop="name">
                <a-input v-model="queryParam.name" placeholder="請輸入名稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="類型" prop="level">
                <a-select v-model="queryParam.level" placeholder="請選擇類型">
                  <a-select-option :value="1">省</a-select-option>
                  <a-select-option :value="2">市</a-select-option>
                  <a-select-option :value="3">縣</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否分配" prop="isAllot">
                <a-select v-model="queryParam.isAllot" placeholder="請選擇是否分配">
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <show-user
        ref="showUser"
        @ok="getList"
      />

      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.isAllot == 0">
            分配用戶
          </a>
          <a @click="cancelAllotData(record.id)" v-if="record.isAllot == 1">
            取消分配
          </a>
           <a-divider type="vertical" />
         <a @click="$refs.showUser.show(record.bindUserId)" v-if="record.isAllot == 1">
            查看賬號
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageArea, delArea,cancelAllot } from '@/api/platform/area'
import CreateForm from './modules/CreateForm'
import ShowUser from './modules/ShowUser'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Area',
  components: {
    CreateForm,
    ShowUser
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        name: null,
        fullname: null,
        location: null,
        pid: null,
        pids: null,
        managename: null,
        level: null,
        sheng: null,
        shi: null,
        xian: null,
        isAllot: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '編號',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '名稱',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '完整名稱',
          dataIndex: 'managename',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
             if(value != null && value != ''){
               return value +"-"+ record.fullname;
             }else{
               return record.fullname;
             }
          }
        },
        {
          title: '等級',
          dataIndex: 'level',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "省"
            }
            if (value == 2) {
              return "市"
            }
            if (value == 3) {
              return "縣"
            }
          }
        },
        {
          title: '是否已分配',
          dataIndex: 'isAllot',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "是"
            }
            if (value == 0) {
              return "否"
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢行政區劃列表 */
    getList () {
      this.loading = true
     pageArea(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    cancelAllotData(id){
      let that = this;
      cancelAllot({"id":id}).then(response => {
        that.$message.success(
          '修改成功',
          3
        )
        this.getList()
      })
    },
    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        fullname: undefined,
        location: undefined,
        pid: undefined,
        pids: undefined,
        managename: undefined,
        level: undefined,
        sheng: undefined,
        shi: undefined,
        xian: undefined,
        isAllot: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delArea(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/area/export', {
            ...that.queryParam
          }, `行政區劃_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
